import actionTypes from 'constants/actionTypes'


export default [
  actionTypes.BOOKMARKS.ONE.EDIT,
  actionTypes.NODES.ONE.EDIT,
  actionTypes.EDGES.ONE.EDIT,
  actionTypes.KINDS.ONE.EDIT
]
